import axios from "axios";

//const
const EQUIPMENT_LIST_UPDATE_DATA = "equipmentList/EQUIPMENT_LIST_UPDATE_DATA";
const EQUIPMENT_LIST_STORE_EQUIPMENTS = "equipmentList/EQUIPMENT_LIST_STORE_EQUIPMENTS";
const EQUIPMENT_LIST_STORE_SHOW_EQUIPMENTS = "equipmentList/EQUIPMENT_LIST_STORE_SHOW_EQUIPMENTS";
const EQUIPMENT_LIST_TOGGLE_MODAL = "equipmentList/EQUIPMENT_LIST_TOGGLE_MODAL";
const EQUIPMENT_LIST_TOGGLE_LOADING = "equipmentList/EQUIPMENT_LIST_TOGGLE_LOADING";

const EQUIPMENT_LIST_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentManagement_EquipmentList_modal_success_title";
const EQUIPMENT_LIST_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentManagement_EquipmentList_modal_fail_title";
const EQUIPMENT_LIST_MODAL_STOP_SUCCESS_CONTENT = "scenes_Equipment_EquipmentManagement_EquipmentList_modal_stopSuccess_content";
const EQUIPMENT_LIST_MODAL_STOP_FAIL_CONTENT = "scenes_Equipment_EquipmentManagement_EquipmentList_modal_stopFail_content";
const EQUIPMENT_LIST_MODAL_OK_LABEL = "scenes_Equipment_EquipmentManagement_EquipmentList_modal_OK_label";
const EQUIPMENT_LIST_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentManagement_EquipmentList_modal_cancel_label";

//reducer
export const equipmentList = (state = {
  loading: false,

  userId: "",
  enterpriseId: "",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  equipments: [],
  showEquipments: [],
  name: "",
  equipmentId: "",
  selectedKey: "",
  selectedKeyEquipment: [],
}, action) => {
  switch (action.type) {
    case EQUIPMENT_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_LIST_STORE_EQUIPMENTS:
      return {
        ...state,
        equipments: action.data,
        showEquipments: action.data,
        selectedKey: "",
        selectedKeyEquipment: [],
      };
    case EQUIPMENT_LIST_STORE_SHOW_EQUIPMENTS:
      return {
        ...state,
        showEquipments: action.data,
        selectedKey: "",
        selectedKeyEquipment: [],
      };
    case EQUIPMENT_LIST_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_LIST_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateEquipmentData = (data) => {
  return {
    type: EQUIPMENT_LIST_UPDATE_DATA,
    data: data
  }
};

/**
 * init equipments
 */
export const initEquipments = (data) => (dispatch) => {
  dispatch(toggleLoading(true));

  dispatch(updateEquipmentData({
    name: "enterpriseId",
    value: data.enterpriseId
  }));

  axios.get(`/api-equipment/getEquipmentList/${data.enterpriseId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipments(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipments
 */
export const storeEquipments = (equipments) => {
  return {
    type: EQUIPMENT_LIST_STORE_EQUIPMENTS,
    data: equipments
  }
};

/**
 * filter equipments
 */
export const filterEquipment = (data) => (dispatch) => {
  let showEquipments = data.equipments.filter(equipment => {
    return equipment.equipmentType.name.indexOf(data.name) > -1
  });
  dispatch(storeShowEquipments(showEquipments));
};

/**
 * store show equipments
 */
export const storeShowEquipments = (equipments) => {
  return {
    type: EQUIPMENT_LIST_STORE_SHOW_EQUIPMENTS,
    data: equipments
  }
};

/**
 * stop equipment
 */
export const stopEquipment = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-equipment/stopEquipmentById/${data.id}`,
    contentType: "application/json",
    withCredentials: true,
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success stop equipment");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: EQUIPMENT_LIST_MODAL_SUCCESS_TITLE,
          modalContent: EQUIPMENT_LIST_MODAL_STOP_SUCCESS_CONTENT,
          modalOk: EQUIPMENT_LIST_MODAL_OK_LABEL,
          modalCancel: EQUIPMENT_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(initEquipments());
            dispatch(toggleModal({modalVisible: false}))
          },
          onCancel: () => {
            dispatch(initEquipments());
            dispatch(toggleModal({modalVisible: false}))
          }
        }));
      } else {
        console.error("fail to stop equipment");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: EQUIPMENT_LIST_MODAL_FAIL_TITLE,
          modalContent: EQUIPMENT_LIST_MODAL_STOP_FAIL_CONTENT,
          modalOk: EQUIPMENT_LIST_MODAL_OK_LABEL,
          modalCancel: EQUIPMENT_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({modalVisible: false}))
          },
          onCancel: () => {
            dispatch(toggleModal({modalVisible: false}))
          }
        }));
      }
    }
  ).catch(
    err => {
      dispatch(toggleLoading(false));
      //设备网关服务无法接通，导致数采服务抛出异常
      console.error("fail to stop equipment", err);
      dispatch(toggleModal({
        modalVisible: true,
        modalTitle: EQUIPMENT_LIST_MODAL_FAIL_TITLE,
        modalContent: EQUIPMENT_LIST_MODAL_STOP_FAIL_CONTENT,
        modalOk: EQUIPMENT_LIST_MODAL_OK_LABEL,
        modalCancel: EQUIPMENT_LIST_MODAL_CANCEL_LABEL,
        onOk: () => {
          dispatch(toggleModal({modalVisible: false}))
        },
        onCancel: () => {
          dispatch(toggleModal({modalVisible: false}))
        }
      }));
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_LIST_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_LIST_TOGGLE_LOADING,
    data: show
  }
};

